import { render, staticRenderFns } from "./systemParameter.vue?vue&type=template&id=27c7a495&scoped=true&"
import script from "./systemParameter.vue?vue&type=script&lang=js&"
export * from "./systemParameter.vue?vue&type=script&lang=js&"
import style0 from "./systemParameter.vue?vue&type=style&index=0&id=27c7a495&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7a495",
  null
  
)

export default component.exports